import { cn } from "../lib/utils"

const numberSizes = {
  xl: "text-[3.5rem] tracking-[-0.045em] sm:text-[5rem]",
  lg: "text-[2.75rem] tracking-[-0.045em] sm:text-[3.5rem]",
  md: "text-[1.75rem] tracking-[-0.03em] sm:text-[2.25rem]",
}

/**
 * Every figure shown large (Account's balances, the samples on web's home):
 * one thin, tabular number in three steps. `xl` is Account Billing's
 * balance, `lg` a card's headline (balances, seats), `md` a stat among
 * others (app usage, a plan's credits). Sizes step with the screen so a
 * five-digit balance still fits a phone.
 */
export function BigNumber({
  value,
  size = "lg",
  as: Tag = "p",
  className,
}: {
  value: string
  size?: keyof typeof numberSizes
  as?: "p" | "dd" | "span"
  className?: string
}) {
  return (
    <Tag
      className={cn(
        "block leading-none font-extralight text-foreground tabular-nums",
        numberSizes[size],
        className
      )}
    >
      {value}
    </Tag>
  )
}
